import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextDiaT2 } from "./TextDiaT2";
import { SourcesDiaT2 } from "./SourcesDiaT2";


export default function Dt2() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};
    

return(
<>      

<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
           <TextCard 
            textcard={'Diabetes Type 2' }
           />
</Button>

<CustomDialog open={open} onClose={handleClose}

        title='Diabetes Type 2 Genes - Variants'

        content={<TextDiaT2 />}

        sources={<SourcesDiaT2 />}

/>

</>
)}